function getTexts() {
    if (typeof poeticsoft_heart_campus_api !== 'undefined' && poeticsoft_heart_campus_api.texts) {
        return poeticsoft_heart_campus_api.texts;
    }

    return {};
}

function escapeHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export function t(key) {
    const texts = getTexts();

    return Object.prototype.hasOwnProperty.call(texts, key) ? String(texts[key]) : key;
}

export default function tHtml(key) {
    return escapeHtml(t(key));
}
